import { AuditLog } from "@common/types/auditLog";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogSplitContent: React.FC<Props> = ({ log }) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );
    const split = log.diff.find((d) => d.field === "splitParentId");

    return (
        <>
            <strong>{authorComponent}</strong>{" "}
            {split?.after?.value ? "split" : "unsplit"} this transaction.
        </>
    );
};
